(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("css-animator/builder", [], factory);
	else if(typeof exports === 'object')
		exports["css-animator/builder"] = factory();
	else
		root["css-animator/builder"] = factory();
})(window, function() {
return 